// eslint-disable-next-line no-unused-vars
const domain = window.location.hostname

const map = {
    "//localhost:8888/": "//scc.sourceaix.com/", // 中控主应用
    "//localhost:8000/": "//sfl.sourceaix.com/", // 产品特征库
    "//localhost:8100/": "//sre.sourceaix.com/", // 调研评测任务管理系统
    "//localhost:8200/": "//sbc.sourceaix.com/", // 基础属性配置系统
    "//localhost:8300/": "//scs.sourceaix.com/", // AI智能客服管理系统
    "//localhost:8400/": "//sdc.sourceaix.com/", // AI分析大屏配置系统
    "//localhost:8500/": "//swp.sourceaix.com/", // 文章写作系统
    "//localhost:8600/": "//smp.sourceaix.com/", // 会议宝
    "//localhost:8700/": "//sft.sourceaix.com/", // 模型微调系统
    "//localhost:8900/": "//svot.sourceaix.com/",// 视频识别训练系统
    "//localhost:8800/": "//sap.sourceaix.com/", // AI监控告警平台
    "//localhost:8890/": "//sfe.sourceaix.com/", // 特征提取系统
    "//localhost:9999/": "//coze.sourceaix.com/",// coze
}

const map2 = {
    "//localhost:8888/": "//t-scc.sourceaix.com/", // 中控主应用
    "//localhost:8000/": "//t-sfl.sourceaix.com/", // 产品特征库
    "//localhost:8100/": "//t-sre.sourceaix.com/", // 调研评测任务管理系统
    "//localhost:8200/": "//t-sbc.sourceaix.com/", // 基础属性配置系统
    "//localhost:8300/": "//t-scs.sourceaix.com/", // AI智能客服管理系统
    "//localhost:8400/": "//t-sdc.sourceaix.com/", // AI分析大屏配置系统
    "//localhost:8500/": "//t-swp.sourceaix.com/", // 文章写作系统
    "//localhost:8600/": "//t-smp.sourceaix.com/", // 会议宝
    "//localhost:8700/": "//t-sft.sourceaix.com/", // 模型微调系统
    "//localhost:8900/": "//t-svot.sourceaix.com/",// 视频识别训练系统
    "//localhost:8800/": "//t-sap.sourceaix.com/", // AI监控告警平台
    "//localhost:8890/": "//t-sfe.sourceaix.com/", // 特征提取系统
    "//localhost:9999/": "//t-coze.sourceaix.com/",// coze
}

// const map = {
//     "//localhost:8888/": `//${domain}:8888/`, // 中控主应用
//     "//localhost:8000/": `//${domain}:8000/`, // 产品特征库
//     "//localhost:8100/": `//${domain}:8100/`, // 调研评测任务管理系统
//     "//localhost:8200/": `//${domain}:8200/`, // 基础属性配置系统
//     "//localhost:8300/": `//${domain}:8300/`, // AI智能客服管理系统
//     "//localhost:8400/": `//${domain}:8400/`, // AI分析大屏配置系统
//     "//localhost:8500/": `//${domain}:8500/`, // 文章写作系统
//     "//localhost:8600/": `//${domain}:8600/`, // 会议宝
//     "//localhost:8700/": `//${domain}:8700/`, // 模型微调系统
//     "//localhost:8900/": `//${domain}:8900/`, // 视频识别训练系统
//     "//localhost:8800/": `//${domain}:8800/`, // AI监控告警平台
//     "//localhost:8890/": `//${domain}:8890/`, // 特征提取系统
//     "//localhost:9999/": `//${domain}:9999/`, // coze
// }

export default function hostMap(host) {
    // eslint-disable-next-line no-constant-condition
    if (process.env.VUE_APP_ENV === "production") return map[host]
    if (process.env.VUE_APP_ENV === "stage") return map2[host]
    return host
}
